'use client';

import { LayoutContainer, Section } from '@petsmart-ui/sparky';

import { getPlpModuleSectionHeading } from '../../utils/plpModuleSectionHeading';
import Tile6UpVisualNav from './Tile6UpVisualNav';
import type { VisualNavigationProps } from './types';

export function VisualNavigation({ variant, header, tiles, isH1 }: VisualNavigationProps) {
    const { title, headingTagName } = getPlpModuleSectionHeading(header, isH1);

    return (
        <LayoutContainer className="visual-navigation-container">
            <Section
                data-testid="visual-navigation-test-id"
                title={title}
                headingTagName={headingTagName}
                className="visual-navigation-section"
            >
                <Tile6UpVisualNav variant={variant} header={header} tiles={tiles} overrideDefaultClass />
            </Section>
        </LayoutContainer>
    );
}

export default VisualNavigation;
